import { isUndefined } from "lodash";
import { areAllElementsNumbers } from "../../../lib/areAllElementsNumbers";
export const validateLogin = (idbg, pin, serverURL) => {
  const messages = {};
  if (typeof idbg === "undefined" || idbg === "") {
    messages.idbg = "Account name is required";
  }
  if (typeof pin === undefined || pin === "") {
    messages.pin = "Pin is required";
  }
  if (Object.values(pin).some((val) => isUndefined(val))) {
    messages.pin = "Pin must have a 6 digits";
  }
  if (pin.length === 6 && !areAllElementsNumbers(pin)) {
    messages.pin = "Pin must be a number";
  }
  if (typeof serverURL === "undefined" || serverURL === "") {
    messages.serverURL = "Server is required";
  }

  if (Object.keys(messages).length > 0) {
    return { valid: false, errors: messages };
  }

  return { valid: true, errors: null };
};
